import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { useEffect } from 'react';
import styled from 'styled-components';

interface Props {
	url: string;
}

const elements = {
	iframe: styled.iframe`
		width: 100%;
		min-height: 300px;
		border: none;
		outline: none;
	`,
};

export function PaymentFrame({ url }: Props): JSX.Element {
	const analyticCtx = useAnalyticContext();

	useEffect(() => {
		analyticCtx.trackEvent('Started payment');
	}, [analyticCtx]);

	return <elements.iframe title={withTranslation('PW.Component.Visits.AppointmentInfo.Payment.Sheet.Iframe.Title')} src={url} />;
}
